import dayjs from 'dayjs'

import { useTranslate } from '@/src/lang/useTranslate'

export const useFormattedDate = (dateStr: string) => {
  const { t } = useTranslate()
  const date = dayjs(dateStr)
  const time = date.format('HH:mm')

  const isToday = dayjs().isSame(date, 'day')

  const formattedDateTime = (() => {
    if (dayjs().isSame(date, 'day')) {
      return t('comment.relative.time.today', { time })
    }

    if (dayjs().subtract(1, 'day').isSame(date, 'day')) {
      return t('comment.relative.time.yesterday', { time })
    }

    if (dayjs().subtract(2, 'days').isBefore(date)) {
      const dayName = date.format('dddd')
      return t('comment.relative.time.week-day', {
        weekday: dayName.charAt(0).toUpperCase() + dayName.slice(1),
        time,
      })
    }

    const formattedDate = date.format('D MMMM YYYY')
    return t('comment.relative.time', { prefix: `${formattedDate} à`, time })
  })()

  const formattedDate = (() => {
    if (dayjs().isSame(date, 'day')) {
      return t('word.today')
    }

    if (dayjs().subtract(1, 'day').isSame(date, 'day')) {
      return t('word.yesterday')
    }

    if (dayjs().subtract(2, 'days').isBefore(date)) {
      const dayName = date.format('dddd')
      return t('comment.relative.week-day', {
        weekday: dayName.charAt(0).toUpperCase() + dayName.slice(1),
      })
    }

    return date.format('D MMMM YYYY')
  })()

  const formattedTime = (() => {
    if (isToday) {
      return t('comment.relative.time.today', { time })
    }
    return time
  })()

  return { formattedDateTime, formattedTime, formattedDate, isToday }
}
